import { render, staticRenderFns } from "./ModuleForm.vue?vue&type=template&id=2cf6a4fa&scoped=true&"
import script from "./ModuleForm.vue?vue&type=script&lang=js&"
export * from "./ModuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf6a4fa",
  null
  
)

export default component.exports